export const Ubie = {
  UbieCard: {
    CardText: 'で調べる',
  },
  UbieDescription: {
    Navigation: '症状を調べた後は、かかりつけ医にもご相談ください。',
    Description:
      '症状検索エンジン「ユビー」は、気になる症状について医師監修の質問に答えるだけで、関連する病気や対処法・近くの医療機関を無料で調べられます。',
  },
};
